import Api from './Api'

class ExternalForm extends Api {

  constructor(version = 'v1') {
    super(version)
    this.path = 'businesskits'
  }

  assign(business_kit_id, project_id) {
    return new Promise((resolve, reject) => {
      this.http.put(this.path + '/' + business_kit_id + '/assign_project', { project_id: project_id }).then(response => {
          resolve(response.data.resource)
        })
        .catch(e => {
          this.handleError(e)
          reject(e)
        })
    })
  }

  send(business_kit_id, lead_id) {
    return new Promise((resolve, reject) => {
      this.http.put(this.path + '/' + business_kit_id + '/send', { lead_id: lead_id }).then(response => {
          resolve(response.data)
        })
        .catch(e => {
          this.handleError(e)
          reject(e)
        })
    })
  }

}

export default ExternalForm


// WEBPACK FOOTER //
// ./src/api/BusinessKit.js